"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _SocketEvents = require("../../constants/SocketEvents");
var _toggleNotificationList = _interopRequireDefault(require("./toggleNotificationList"));
var _constants = require("@studio/constants");
var _excluded = ["attendeeId", "name", "presenterPhoto"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function knockReceived(knockPayload) {
  return function (dispatch, getState, socket) {
    var _knockPayload;
    var _getState = getState(),
      attendeeRoster = _getState.attendeeRoster,
      broadcast = _getState.broadcast,
      attendeeResponse = _getState.meeting.attendeeResponse;

    // If attendeeId already exists in attendeeRoster update it to the new name
    if ((_knockPayload = knockPayload) !== null && _knockPayload !== void 0 && _knockPayload.attendeeId) {
      var _knockPayload2 = knockPayload,
        attendeeId = _knockPayload2.attendeeId,
        name = _knockPayload2.name,
        presenterPhoto = _knockPayload2.presenterPhoto,
        rest = _objectWithoutProperties(_knockPayload2, _excluded);
      attendeeRoster[attendeeId] = {
        name: name,
        role: _constants.SOURCE_ROLE_SPEAKER,
        presenterPhoto: presenterPhoto
      };
      knockPayload = rest;
      socket.emit(_SocketEvents.ATTENDEE_ROSTER_CHANGE, {
        attendeeRoster: attendeeRoster,
        broadcastId: broadcast === null || broadcast === void 0 ? void 0 : broadcast._id,
        notifyingDirector: attendeeResponse && attendeeResponse.Attendee.AttendeeId
      });
    }
    var action = {
      type: _types.BROADCAST_RECEIVE_KNOCK,
      payload: _objectSpread({}, knockPayload)
    };
    dispatch(action);

    // Toggle notification list
    dispatch((0, _toggleNotificationList["default"])(true));
  };
}
var _default = exports["default"] = knockReceived;